import EDC from '@/components/games/shared/globals';
import { getAvatarNameByPath } from '@/helpers/profile/avatar';

class AvatarItem {
  get avatarName() {
    return getAvatarNameByPath(this.data.img);
  }

  constructor(scene, parent, x, y, data) {
    this.scene = scene;
    this.parent = parent;
    this.data = data;
    this.overlay = null;
    this.cropSize = this.scene.gameConfig.cropSize;
    this.frameBorderWidth = 12;
    this.x = x;
    this.y = y;
    this.selectedDelta = 40;
    this.avatar = null;
    this.frame = null;
    this.frameSelected = null;
    this.isActive = false;
    this.cursorManager = scene.cursorManager;

    return this;
  }

  create() {
    this.x += this.selectedDelta;
    this.y += this.selectedDelta;
    this.frame = this.scene.add.sprite(this.x, this.y, 'item-bg').setOrigin(0);
    this.frameBorder = this.scene.add.sprite(this.x, this.y, 'item-border').setOrigin(0);
    this.frameSelected = this.scene.add.sprite(this.x - this.selectedDelta,
      this.y - this.selectedDelta,
      'item-selected').setOrigin(0);
    this.frameSelected.setAlpha(0);
    this.avatar = this.scene.add.sprite(this.x, this.y,
      `avatar-${this.avatarName}`).setDisplayOrigin(this.data.crop.x, this.data.crop.y);
    this.avatar.setCrop(this.data.crop.x, this.data.crop.y,
      this.cropSize.width,
      this.cropSize.height);
    this.overlay = this.scene.add.graphics(this.x + this.frameBorderWidth,
      this.y + this.frameBorderWidth);
    this.overlay.fillStyle(0x000000, 0.7);
    this.overlay.fillRect(0, 0, this.cropSize.width, this.cropSize.height);

    this.cursorManager.setDefaultDraggableEvents(this.frame);
    this.frame.setInteractive();
    this.frame.on('pointerover', this.onHover, this);
    this.frame.on('pointerout', this.onHoverOut, this);
    this.frame.on('pointerup', this.activate, this);
    this.addToParent();
    return this;
  }

  onHover() {
    if (this.isActive) return;
    this.overlay.setAlpha(0);
  }

  onHoverOut() {
    if (this.isActive) return;
    this.overlay.setAlpha(1);
  }

  activate() {
    if (this.isActive) return;
    this.frameSelected.setAlpha(1);
    this.overlay.setAlpha(0);
    this.isActive = true;
    this.scene.events.emit(this.scene.gameConfig.signals.S_ITEM_ACTIVATED, this);
  }

  deactivate() {
    this.frameSelected.setAlpha(0);
    this.overlay.setAlpha(1);
    this.isActive = false;
  }

  removeFromParent() {
    this.parent
      .remove([this.frame, this.avatar, this.overlay, this.frameSelected, this.frameBorder]);
  }

  addToParent() {
    this.parent.add([this.frame, this.avatar, this.overlay, this.frameSelected, this.frameBorder]);
  }

  place(x, y) {
    this.x = x + this.selectedDelta;
    this.y = y + this.selectedDelta;
    this.frame.setPosition(this.x, this.y);
    // this.frameBorder.setScale(1.05);
    this.frameBorder.setPosition(this.x, this.y);
    this.frameSelected.setPosition(this.x - this.selectedDelta, this.y - this.selectedDelta);
    this.avatar.setPosition(this.x + this.frameBorderWidth, this.y + this.frameBorderWidth);
    this.overlay.setPosition(this.x + this.frameBorderWidth, this.y + this.frameBorderWidth);
  }
}

EDC.Games.AvatarSelect.AvatarItem = AvatarItem;

export default AvatarItem;
